import additionalFilters from './additionalFilters'
import alternateArt from './altenateArt'
import auth from './auth'
import cards from './cards'
import clipboard from './clipboard'
import { firebaseReducer } from 'react-redux-firebase'
import { firestoreReducer } from 'redux-firestore'
import hardSet from 'redux-persist/lib/stateReconciler/hardSet'
import localStorage from 'redux-persist/lib/storage'
import misc from './misc'
import pagedata from './pagedata'
import { persistReducer } from 'redux-persist'
import settings from './settings'
import toasts from './toasts'
import typeahead from './typeahead'

const reducers = {
  additionalFilters,
  alternateArt,
  auth,
  cards,
  clipboard,
  firebase: persistReducer(
    { key: 'firebaseState', stateReconciler: hardSet, storage: localStorage },
    firebaseReducer
  ),
  firestore: firestoreReducer,
  misc,
  pagedata,
  settings,
  toasts,
  typeahead,
}

export default reducers
